{ "id": "incarnam", "name": "Incarnam", "generator": "incarnam",
  "roomPool": ["prairie", "champs", "foret", "clairiere", "lac", "cimetiere"], "bossRoom": "clairiere",
  "encounters": [
    [ { "monsters": [ { "id": "*", "count": 5 } ] }, { "monsters": [ { "id": "*", "count": 6 } ] } ],
    [ { "monsters": [ { "id": "*", "count": 6 } ] }, { "monsters": [ { "id": "*", "count": 7 } ] } ],
    [ { "monsters": [ { "id": "*", "count": 6 } ] }, { "monsters": [ { "id": "*", "count": 7 } ] }, { "monsters": [ { "id": "*", "count": 6 } ] } ],
    [ { "monsters": [ { "id": "*", "count": 7 } ] }, { "monsters": [ { "id": "*", "count": 8 } ] } ],
    [ { "monsters": [ { "id": "*", "count": 7 } ] }, { "monsters": [ { "id": "*", "count": 8 } ] }, { "monsters": [ { "id": "*", "count": 8 } ] } ]
  ],
  "bossWaves": [ { "monsters": [ { "id": "milimilou", "count": 1 }, { "id": "*", "count": 3 } ] } ],
  "doorWeights": { "kamas": 3, "xp": 3, "marchand": 2, "coffre": 2, "fontaine": 2, "defi": 2 } }
